import { render } from "./FormularioCargoFuncionario.vue?vue&type=template&id=0cdb345b&scoped=true"
import script from "./FormularioCargoFuncionario.vue?vue&type=script&lang=js"
export * from "./FormularioCargoFuncionario.vue?vue&type=script&lang=js"

import "./FormularioCargoFuncionario.vue?vue&type=style&index=0&id=0cdb345b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdb345b"]])

export default __exports__